module.exports = __webpack_public_path__ + "img/paper-plane.8ee4c537.svg";